export function isLocalhost(input: string): boolean {
  try {
    // In case of full URL is provided, extract the hostname
    const hostname = new URL(input).hostname;

    const localhostRegex = /^(localhost|127\.0\.0\.1|::1)$/;
    return localhostRegex.test(hostname);
  } catch {
    // In case only hostname is provided
    const localhostRegex = /^(localhost|127\.0\.0\.1|::1)$/;
    return localhostRegex.test(input);
  }
}
